var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ribbon"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"ribbon-container"},[_c('a',{attrs:{"href":_vm.url}},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.primaryText)}}),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.secondaryText)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }